export class Question{
  title: string;
  type:string;
  noofoptions:string;
}
